<template>
  <span class="wrap-icon">
    <i class="public-icon search-icon" :class="name" v-if="type == 1"></i>
    <i class="public-icon user-center-icon" :class="name" v-if="type == 2"></i>
    <i class="public-icon tabbar-icon" :class="name" v-if="type == 3"></i>
    <i class="public-icon finace-icon" :class="name" v-if="!type"></i>
  </span>
</template>
<script>
export default {
  name: 'PublicIcon',
  props: {
    name: String, // 1 se-icon  2 user-center-icon  3tabbar-icon
    type: [Number, String]
  },
  data() {
    return {}
  }
}
</script>
<style lang="less" scoped>
.wrap-icon {
  display: inline-block;
  vertical-align: bottom;
}
</style>



// WEBPACK FOOTER //
// src/components/PublicIcon.vue